<template>
	<v-dialog v-model="dialog" max-width="700" content-class="test-class" scrollable>
		<v-card >
			<v-card-title>
				Wybierz grupę
				<v-btn icon @click="closeDialog()" class="ml-auto">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="relative">
				<v-overlay
					v-if="saving"
					:value="true"
					absolute
					:dark="false"
					light
					color="white"
					opacity="0.8"
					>
					<v-progress-circular
						indeterminate
						size="50"
					></v-progress-circular>
				</v-overlay>
				<v-text-field
					v-model="search"
					@input="onInput()"
					placeholder="Szukaj..."
					outlined
					dense
					prepend-inner-icon="mdi-magnify"
					hide-details
					:loading="loading"
				></v-text-field>
				<div v-if="loading" class="mt-5">
					<template v-for="n in 3">
						<v-skeleton-loader
							:key="n"
							type="list-item-avatar, card-action"
							class="py-3"
						></v-skeleton-loader>
						<v-divider :key="`divider-${n}`"/>
					</template>
				</div>
				<v-list v-else-if="groups.data.length">
					<template v-for="(item, index) in groups.data">
						<v-list-item v-if="item.permissions.status == 'accepted'" :key="item.id" class="d-flex py-3">
							<div>
								<avatar :group="item" />
							</div>
							<div class="pl-2 flex-grow-1">
								<div class="d-flex justify-content-between">
									<router-link :to="{ name: 'Group', params: { id: item.id } }" class="text-decoration-none">
										<div class="grey--text text--darken-2 font-weight-bold font-16">
											{{ item.name }}
										</div>
										<div class="grey--text">
											{{ item.users_count }} członków w grupie
										</div>
									</router-link>
									<div>
										<div class="d-flex">
											<div>
												<v-btn
													:ripple="false"
													color="white"
													elevation="0"
													class="grey--text mr-3"
													style="pointer-events: none"
												>
													<template v-if="item.is_public">
														<v-icon class="font-14 mr-2">mdi-web</v-icon> Publiczna
													</template>
													<template v-else>
														<v-icon class="font-14 mr-2">$ban</v-icon> Prywatna
													</template>
												</v-btn>
											</div>
											<div>
												<v-btn
													@click="selectGroup(item)"
													color="accent"
													elevation="0"
												>
													Wybierz
												</v-btn>
												
												
											</div>
										</div>
									</div>
								</div>
								<div v-if="item.description" class="mt-3 font-12 grey--text text--darken-2">
									{{ item.description }}
								</div>
							</div>	
						</v-list-item>
						<v-divider v-if="index != groups.length - 1" :key="'divider-' + index"/>
					</template>
					
				</v-list>
				<div v-else class="pa-5 text-center">Nie znaleziono grup</div>
			</v-card-text>
			<v-card-actions class="justify-content-center py-3">
				<v-btn color="light" elevation="0" @click="closeDialog()">{{ $vuetify.lang.t('$vuetify.cancel')}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Avatar from '@/components/Avatar'
import {mapGetters} from 'vuex';
import _ from 'lodash';
export default {
	props: {
		saving: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dialog: true,
			search: '',
			loading: false,
			groups: {
				data: [],
				meta: {}
			}
		}
	},
	components: {
		Avatar
	},
	computed: {
		...mapGetters({
			// groups: 'groups/userGroups'
		})
	},
	methods: {
		selectGroup(group) {
			this.$emit('selected', group);
			this.$emit('close');
		},
		async onInput() {
			await this.getGroups();
		},
		async getGroups() {
			this.loading = true;
			let res = await this.$store.dispatch('groups/getUserGroups', {
				params: {
					name: this.search,
					per_page: 10000
				}
			});
			this.loading = false;
			console.log("RES", res)
			this.groups = res.data;
			return res;
		},
		showDialog() {
			if(!this.groups.data.length) {
				this.getGroups();
			}	
			this.dialog = true;
		},
		closeDialog() {
			this.$emit('closed');
		}
	},
	created() {
		this.onInput = _.debounce(this.onInput, 400);
	}
}
</script>